module.exports = __webpack_public_path__ + "img/item3.c7d38547.png";